import { APP_INITIALIZER, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { jwtDecode } from 'jwt-decode';
import { SessionStorageService } from '../services/session-storage.service';
import { SessionRehydratedEvent } from '../../features/auth/state-management/auth.events';
import AppState from '../../app.state';

interface JwtPayload {
  exp?: number;
  [key: string]: unknown;
}

export const SESSION_INITIALIZER = {
  provide: APP_INITIALIZER,
  useFactory: () => {
    const sessionStorageService = inject(SessionStorageService);
    const store = inject(Store<AppState>);

    return () => {
      const data = sessionStorageService.load();

      if (!data) {
        return;
      }

      try {
        const decoded = jwtDecode<JwtPayload>(data.authorizationToken);

        if (typeof decoded.exp !== 'number' || decoded.exp <= Date.now() / 1000) {
          sessionStorageService.clear();
          return;
        }

        store.dispatch(
          SessionRehydratedEvent({
            authenticationToken: data.authenticationToken,
            authorizationToken: data.authorizationToken,
            resources: data.resources,
            selectedUserKind: data.selectedUserKind,
          })
        );
      } catch {
        // JWT malformed — clear and continue with initialAuthState
        sessionStorageService.clear();
      }
    };
  },
  multi: true,
};
